/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Crosspostingcreatedat2Inputs */

const en_crosspostingcreatedat2 = /** @type {(inputs: Crosspostingcreatedat2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Created ${i?.date}`)
};

const de_crosspostingcreatedat2 = /** @type {(inputs: Crosspostingcreatedat2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erstellt ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Created {date}" |
*
* @param {Crosspostingcreatedat2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingcreatedat2 = /** @type {((inputs: Crosspostingcreatedat2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingcreatedat2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingcreatedat2(inputs)
	return de_crosspostingcreatedat2(inputs)
});
export { crosspostingcreatedat2 as "crosspostingCreatedAt" }